import React from "react";
import { useSiteContent } from "../context/ContentContext";
import { ButtonLink } from "../components/ButtonLink";
import {
  Breadcrumbs,
  Card,
  HoursTable,
  PageHero,
  SectionHeading,
  TextBlock,
} from "../components/RedlandComponents";
import { ImageGallery } from "../components/ImageGallery";

export default function SandTrap() {
  const { hours, contact, sandTrap } = useSiteContent();
  return (
    <>
      <Breadcrumbs current="The Sand Trap" />
      <PageHero
        eyebrow={sandTrap.subtitle}
        title={sandTrap.title}
        copy="Breakfast, lunch, and dinner hospitality at Redland Golf & Country Club."
        image={sandTrap.heroImage}
        badge="Breakfast, Lunch, Dinner, and Drinks"
        tags={["Kitchen hours", "Post-round dining", "Extension 4"]}
        metaTitle="The Sand Trap"
        metaItems={["Event nights may have extended hours", "Call 305-247-8503", "Extension 4"]}
        variant="warm"
        actions={<ButtonLink href={contact.phoneHref}>Call Extension 4</ButtonLink>}
      />
      <section className="section">
        <div className="container narrow">
          <TextBlock text={sandTrap.intro} />
        </div>
      </section>
      <section className="section section-cream">
        <div className="container">
          <SectionHeading
            title="The Sand Trap Menus"
            copy="Browse breakfast, lunch, dinner, sandwiches, wraps, salads, and sides. Select a menu page to view it larger."
          />
          <ImageGallery items={sandTrap.menuGallery} title="Sand Trap menu gallery" variant="menu" />
        </div>
      </section>
      <section className="section">
        <div className="container">
          <SectionHeading title="Restaurant Hours" copy={hours.effectiveDate} />
          <Card>
            <HoursTable rows={hours.rows} />
            <p className="fine-print">{hours.notice}</p>
            <p className="fine-print">
              Contact: <a href={contact.phoneHref}>305-247-8503, extension 4</a>.
            </p>
          </Card>
        </div>
      </section>
    </>
  );
}
